import React from 'react'
import { Button } from '@mui/material'
import type { AnnouncementFooterProps } from './types'

const AnnouncementFooter: React.FC<AnnouncementFooterProps> = ({ buttonDetails }) => {
  if (!buttonDetails) return null

  const { text, variant, route } = buttonDetails

  return (
    <Button variant={variant} href={route} color="primary" fullWidth>
      {text}
    </Button>
  )
}

export default AnnouncementFooter
